"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetUsers = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const react_query_1 = require("@tanstack/react-query");
const axios_1 = tslib_1.__importDefault(require("axios"));
function getUsersRequestConfig() {
    return {
        restApiVersion: '3.16',
        serverWideRequest: false,
        endpoint: `users`,
        httpMethod: 'GET',
    };
}
function getUsersRequestParams(luids) {
    const paramsMap = {};
    let filter = '';
    if (luids.size > 0) {
        filter += `luid:in:[${[...luids].join(',')}]`;
        paramsMap['filter'] = filter;
    }
    return paramsMap;
}
function queryUsersOnSite({ luids, makeJsonRestApiRequest }) {
    axios_1.default.defaults.baseURL = window.location.origin;
    return makeJsonRestApiRequest(getUsersRequestConfig(), undefined, getUsersRequestParams(luids));
}
function getRestUsers({ luids, makeJsonRestApiRequest }) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (luids.size === 0) {
            return new Map();
        }
        const result = yield queryUsersOnSite({ luids, makeJsonRestApiRequest });
        return new Map(result.users.user.map(({ id, name, fullName, domain }) => [id, {
                username: name !== null && name !== void 0 ? name : null,
                name: fullName !== null && fullName !== void 0 ? fullName : null,
                domain: domain.name,
            }]));
    });
}
function useGetUsers(luids) {
    const queryFn = (0, catalog_core_1.useRestFn)(getRestUsers);
    const { isLoading, data: users } = (0, react_query_1.useQuery)({
        queryKey: ['users', ...[...luids].sort()],
        queryFn: () => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield queryFn({ luids }); }),
        enabled: luids.size > 0,
        refetchOnWindowFocus: false,
        initialData: new Map(),
        placeholderData: new Map(),
    });
    return { users, loading: isLoading };
}
exports.useGetUsers = useGetUsers;
//# sourceMappingURL=getUsers.js.map